import React, { PropsWithChildren, useCallback } from 'react';
import { Button, Col, Grid, Modal, Row, Text } from 'rsuite';
import ResponsiveModal from '../../../ResponsiveModal';

export interface SummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  address: string;
  periodLabel: string;
}

/** Modal that displays the selected period and license summary (e.g. on small screens). */
export const SummaryModal = React.memo(
  ({
    isOpen,
    onClose,
    address,
    periodLabel,
    children,
  }: PropsWithChildren<SummaryModalProps>) => {
    const handleClose = useCallback(() => {
      onClose();
    }, [onClose]);
    return (
      <ResponsiveModal
        isOpen={isOpen}
        onClose={handleClose}
        ariaLabel="tax-confirm-and-sign"
      >
        <Modal.Body style={{ marginTop: '10px', paddingLeft: '4px' }}>
          <Grid fluid>
            <Row>
              <Col xs={24}>
                <Text className="text-bold mb-16">{periodLabel}</Text>
              </Col>
            </Row>
            <Row>
              <Col xs={24}>
                <Text className="text-bold mb-16">{address}</Text>
              </Col>
            </Row>
            <Row>
              <Col xs={24}>{children}</Col>
            </Row>
          </Grid>
        </Modal.Body>
        <Modal.Footer style={{ padding: '10px' }}>
          <Button
            onClick={handleClose}
            className="btn-primary"
            style={{ width: '100%' }}
          >
            Close
          </Button>
        </Modal.Footer>
      </ResponsiveModal>
    );
  }
);

SummaryModal.displayName = 'SummaryModal';
